module.exports = __webpack_public_path__ + "static/match-d9f3aeae73344e3a0372d0ae40bdc6b0.png";